export default __webpack_public_path__ + "static/media/dragon_modal.049fc1bc.svg";